import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import {
  validaSoloNumero,
  validaHora,
  formatoHora,
} from "../../../util/varios";
import "react-tabs/style/react-tabs.css";
import axios from "axios";
import { DangerButton, SuccessButton } from "../../../ui/buttons/Button";
import { Input, Select, Textarea } from "../../../ui/inputs/Input";

export const ModalInsertarExpendio = (props) => {
  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [activate, setActivate] = useState(false);
  const txtCodigoCiu = useRef();
  const txtAlicuota = useRef();
  const txtDescripcionActi = useRef();
  const txtAnios = useRef();
  const txtCodActividad = useRef();
  const [operacion, setOperacion] = useState(0);
  const txtDescripcion = useRef();
  const txtId = useRef();
  const txtDesde = useRef();
  const txtHasta = useRef();
  const txtSelectDesde = useRef();
  const txtSelectHasta = useRef();
  const [desde, setDesde] = useState();
  const [hasta, setHasta] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (
      mensaje.texto == "registro creado correctamente." ||
      mensaje.texto == "registro eliminado correctamente." ||
      mensaje.texto == "registro modificado correctamente."
    ) {
      blanquear();
      props.onHideRender();
      props.onHideCancela();
    }
  };

  const blanquear = () => {
    txtId.current.value = "";
    txtDescripcion.current.value = "";
    txtDesde.current.value = "";
    txtHasta.current.value = "";
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      if (event.target.id === "inputCodigo") {
        txtCodActividad.current.focus();
      } else if (event.target.id === "inputCodigoActi") {
        txtCodigoCiu.current.focus();
      } else if (event.target.id === "inputCodigoCiu") {
        txtAnios.current.focus();
      } else if (event.target.id === "inputAnio") {
        txtDescripcionActi.current.focus();
      } else if (event.target.id === "inputDescripcion") {
        txtAlicuota.current.focus();
      } else if (event.target.id === "inputActualizada") {
        btnAcepta.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      return false;
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const handleInputHoraChange = (event) => {
    validaHora(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value > 12) {
        setMensaje({
          mostrar: true,
          titulo: "Notificacion",
          texto: "El Horario no puede ser mayor a 12Hrs.",
          icono: "informacion",
        });
        if (event.target.name == "inputDesde") {
          txtDesde.current.focus();
        } else if (event.target.name == "inputHasta") {
          txtHasta.current.focus();
        }
      } else {
        event.target.value = formatoHora(event.target.value);
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const salir = () => {
    props.onHideCancela();
    blanquear();
  };

  const selectRegValor = (operacion) => {
    let endpoint = `${op.conexion}/api/licores/actualizarexpendio/${operacion}`;
    let body;
    setActivate(true);

    let Abierto = null;
    let Cerrado = null;
    let abi,
      cerr = 0;
    if (operacion === 1 || operacion === 2) {
      if (desde == "PM") {
        abi = parseInt(txtDesde.current.value.substring(0, 2)) + 12;
        Abierto =
          abi.toString() + txtDesde.current.value.substring(2, 5) + ":00";
        console.log("hola");
      } else {
        Abierto = txtDesde.current.value.trim() + ":00";
      }
      if (hasta == "PM") {
        cerr = parseInt(txtHasta.current.value.substring(0, 2)) + 12;
        Cerrado =
          cerr.toString() + txtHasta.current.value.substring(2, 5) + ":00";
      } else {
        Cerrado = txtHasta.current.value.trim() + ":00";
      }
    } else {
      Cerrado = txtHasta.current.value.trim() + ":00";
      Abierto = txtDesde.current.value.trim() + ":00";
    }
    body = {
      nid: parseInt(txtId.current.value),
      descr: txtDescripcion.current.value,
      abi: Abierto.toString(),
      cerr: Cerrado.toString(),
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente.",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente.",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente.",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const validar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (operacion !== 4) {
      if (txtDescripcion.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "La Descripcion no debe estar vacio",
          icono: "informacion",
        });
        txtDescripcion.current.focus();
        sigue = false;
      } else if (txtDesde.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar el Inicio del Horario",
          icono: "informacion",
        });
        txtDesde.current.focus();
        sigue = false;
      } else if (txtDesde.current.value.substring(3, 5) > 59) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Los Minutos No pueden ser Mayor del Rango",
          icono: "informacion",
        });
        txtDesde.current.focus();
        sigue = false;
      } else if (txtSelectDesde.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Seleccionar un Horario",
          icono: "informacion",
        });
        txtSelectDesde.current.focus();
        sigue = false;
      } else if (txtHasta.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar el Fin del Horario",
          icono: "informacion",
        });
        txtHasta.current.focus();
        sigue = false;
      } else if (txtHasta.current.value.substring(3, 5) > 59) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Los Minutos No pueden ser Mayor del Rango",
          icono: "informacion",
        });
        txtHasta.current.focus();
        sigue = false;
      } else if (txtSelectHasta.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Seleccionar un Horario",
          icono: "informacion",
        });
        txtSelectHasta.current.focus();
        sigue = false;
      } else if (sigue === true) {
        selectRegValor(props.operacion);
      }
    }
  };

  const onChange = (event) => {
    if (event.target.name === "inputDescripcion") {
      event.target.value = event.target.value.toUpperCase();
    }
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion === 1) {
          blanquear();
        }
      }}
      className="shadow-lg"
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
        <h3 className="fw-bold m-0">
          {operacion === 1
            ? "Incluir Tasa"
            : operacion === 2
            ? "Editar Tasa"
            : operacion === 3
            ? "Elminar Tasa"
            : "Consultar Tasa"}{" "}
        </h3>
        <a
          type="button"
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          onClick={salir}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
          <div className="col-3 m-0 mb-2 p-0">
            <Input
              label="Código:"
              disabled
              ref={txtId}
              defaultValue={props.idtipoexpendio}
              id="inputRitm"
              onKeyUp={handleInputChange}
              onBlur={handleInputChange}
            />
          </div>
          <div className="col-12 m-0 mb-2 p-0">
            <Textarea
              label="Descripción:"
              disabled={operacion === 1 ? false : operacion == 2 ? false : true}
              style={{ height: 70 }}
              rows={1}
              ref={txtDescripcion}
              id="inputDescripcion"
              name="inputDescripcion"
              defaultValue={
                props.tipoTasa
                  ? props.tipoTasa.descripcion !== null
                    ? props.tipoTasa.descripcion.trim()
                    : ""
                  : ""
              }
              onChange={onChange}
            />
          </div>
          <div className="col-6 m-0 p-0 d-flex">
            <Input
              label="Desde:"
              disabled={operacion === 1 ? false : operacion == 2 ? false : true}
              ref={txtDesde}
              maxLength={5}
              id="inputDesde"
              name="inputDesde"
              defaultValue={
                props.tipoTasa
                  ? props.tipoTasa.horaabierto !== null
                    ? props.tipoTasa.horaabierto.trim()
                    : ""
                  : ""
              }
              onKeyUp={handleInputHoraChange}
              onBlur={handleInputHoraChange}
            />
            <Select
              name="selectDesde "
              disabled={operacion === 1 ? false : operacion == 2 ? false : true}
              onChange={(event) => setDesde(event.target.value)}
              ref={txtSelectDesde}
              defaultValue={props.tipoTasa && props.tipoTasa.apabierto}
            >
              <option key="" value="">
                Seleccionar
              </option>
              <option key="1" value="AM">
                AM
              </option>
              <option key="2" value="PM">
                PM
              </option>
            </Select>
          </div>
          <div className="col-6 m-0 p-0 pl-2 d-flex">
            <Input
              label="Hasta:"
              disabled={operacion === 1 ? false : operacion == 2 ? false : true}
              ref={txtHasta}
              maxLength={5}
              id="inputHasta"
              name="inputHasta"
              defaultValue={
                props.tipoTasa
                  ? props.tipoTasa.horacerrado !== null
                    ? props.tipoTasa.horacerrado.trim()
                    : ""
                  : ""
              }
              onKeyUp={handleInputHoraChange}
              onBlur={handleInputHoraChange}
            />
            <Select
              name="selectHasta"
              disabled={operacion === 1 ? false : operacion == 2 ? false : true}
              onChange={(event) => setHasta(event.target.value)}
              ref={txtSelectHasta}
              defaultValue={props.tipoTasa && props.tipoTasa.apcerrado}
            >
              <option key="" value="">
                Seleccionar
              </option>
              <option key="1" value="AM">
                AM
              </option>
              <option key="2" value="PM">
                PM
              </option>
            </Select>
          </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          disabled={operacion === 4 ? true : false}
          onClick={validar}
        >
          Aceptar
        </SuccessButton>
        <DangerButton ref={btnCancela} onClick={salir}>
          Salir
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
        }}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
